
/* jshint browser: true */

var hasCheckValidity = typeof document.createElement('input').checkValidity === 'function'

export default function validate(url) {
  // TO DO
  if (!hasCheckValidity) return null

  var input = document.createElement('input')
  input.type = 'url'
  input.value = url
  if (!input.checkValidity()) return false
  return url
}
